import DashboardContainer from "../../Components/Dashboard";
import { useEffect } from "react";

const Dashboard = () => {
  useEffect(() => {
    document.title = "HRIS Dashboard";
  }, []);
  return <DashboardContainer />;
};

export default Dashboard;
